import { useAppSelector } from "@app/hooks"
import OptionsButton2, { ItemModel } from "@cmp/buttons/optionsButton2"
import { selectStudent } from "@features/program/programSliceSelectors"
import { SvgIcon } from "@mui/material"
import appIcons from "@utils/appIcons"
import { buildStudentActions } from "./studentActions"

export const StudentActionsMenu = (props: {
  studentId: string
  studentName: string
  studentCurrentClass: string
  programId: string | undefined
  programType: "legacy" | "next-gen"
  classId: string | undefined
}) => {
  const { studentId, programId, classId, studentName, programType } = props
  const student = useAppSelector(selectStudent(programId, classId, studentId))
  if (!student) {
    return
  }

  // The one canonical action set (see studentActions.ts) — this menu just
  // renders it. The students page renders the same list, so the two can't drift.
  const items: ItemModel[] = buildStudentActions({
    studentId,
    name: studentName,
    firstName: student.firstName,
    lastName: student.lastName,
    email: student.email,
    programId,
    // Each class id goes where it went before: route class (offboard),
    // registration class (language), current class (class transfer).
    classId,
    registrationClassId: student.classId,
    mentorId: student.mentor?.id,
    hasMentor: student.mentor !== undefined && student.mentor !== null,
    csaClientId: student.careerSuccessAdvisor?.userClientId,
    hasCsa:
      student.careerSuccessAdvisor !== undefined &&
      student.careerSuccessAdvisor !== null,
    programType,
  }).map((action) =>
    action.kind === "divider"
      ? { type: "divider", props: { key: action.key } }
      : {
          type: "menu-item",
          props: {
            key: action.key,
            children: action.label,
            onClick: action.onClick,
            ...(action.danger ? { sx: { color: "error.main" } } : {}),
          },
        },
  ) as ItemModel[]

  return (
    <OptionsButton2
      buttonModel={{
        type: "icon",
        props: {
          sx: {
            marginLeft: "auto",
            display: "flex",
          },
          size: "small",
          children: (
            <SvgIcon
              component={appIcons.dotsHorizontal}
              inheritViewBox
              sx={{ color: "primary.main" }}
            />
          ),
        },
      }}
      items={items}
    />
  )
}
